import { render, staticRenderFns } from "./VuesticTreeRoot.vue?vue&type=template&id=344785bf"
import script from "./VuesticTreeRoot.vue?vue&type=script&lang=js"
export * from "./VuesticTreeRoot.vue?vue&type=script&lang=js"
import style0 from "./VuesticTreeRoot.vue?vue&type=style&index=0&id=344785bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-tree-view/VuesticTreeRoot.vue
// module id = vHzh
// module chunks = 41